const dayStartChoicesSrb = [
  {
    label: "Са миром ујутру шетњом поред мора.",
    value: 'With a peaceful morning walk by the sea.{"Blue":"3","Violet":"2"}',
  },

  {
    label: "Са активним вежбањем.",
    value: 'With an active workout.{"Red":"3","Yellow":"2"}',
  },

  {
    label: "Са топлом шољицом кафе у угодном углу.",
    value:
      'With a warm cup of coffee in a cozy corner.{"Brown":"3","Green":"2"}',
  },

  {
    label: "Са тихим тренутком медитације у минималистичком простору.",
    value:
      'With a quiet moment of meditation in a minimalist space.{"Gray":"3","Black":"2"}',
  },
];

export default dayStartChoicesSrb;
